export default __webpack_public_path__ + "static/media/logo_ppp-ar_request.d464712f.png";